import { mockCardPaymentOption, mockOfferDetails } from '@domgen/dgx-fe-basket';
import { CompletedOfferDetails } from '../../models/completed-offer/completed-offer-details.interface';
import { mockCheckoutCompletedOfferConfirmation } from '../checkout-completed-item/checkout-completed-offer-confirmation.mock';

export const mockCompletedOfferDetails: CompletedOfferDetails = {
  ...mockOfferDetails,
  ...mockCheckoutCompletedOfferConfirmation,
  purchasedPaymentOption: mockCardPaymentOption,
};
